<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="AddNewDevice-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.LoginRegister_back" leftIcon="arrowLeft" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="AddNewDevice-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="AddNewDevice-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="AddNewDevice-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91c0-25.23,2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91c0,25.23-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <g transform="translate(386.91 -62.998)">
              <path class="AddNewDevice-st2" d="M-351.74,141.02v-16.39h16.42v16.39H-351.74z M-338.54,137.78c0-3.22,0.01-6.26-0.02-9.29c0-0.22-0.36-0.62-0.55-0.62c-3.07-0.04-6.14-0.03-9.37-0.03c0,3.21-0.01,6.28,0.03,9.35c0.09,0.28,0.32,0.49,0.61,0.57C-344.82,137.8-341.78,137.78-338.54,137.78z"/>
              <path class="AddNewDevice-st2" d="M-351.73,114.6V98.34h16.41v16.26H-351.73z M-348.44,111.38c3.18,0,6.21,0.02,9.24-0.04c0.23,0,0.64-0.58,0.65-0.89c0.05-2.62,0-5.24,0.05-7.87c0.01-0.83-0.28-1.07-1.08-1.06c-2.58,0.04-5.16,0.01-7.74,0.02c-0.36,0-0.71,0.06-1.11,0.1V111.38z"/>
              <path class="AddNewDevice-st2" d="M-309.02,114.61h-16.27V98.33h16.27V114.61z M-317.29,111.38c1.37,0,2.75-0.01,4.12,0.01c0.59,0.01,0.93-0.15,0.93-0.83c-0.02-2.75,0.01-5.49-0.05-8.24c-0.13-0.37-0.43-0.64-0.81-0.73c-2.7-0.06-5.41-0.02-8.12-0.05c-0.66-0.01-0.87,0.27-0.87,0.89c0.02,2.66,0.03,5.33-0.01,7.99c-0.01,0.81,0.35,0.98,1.06,0.96C-319.79,111.35-318.54,111.37-317.29,111.38L-317.29,111.38z"/>
              <path class="AddNewDevice-st2" d="M-331.94,121.25h-13.18v-3.21h16.48v6.47h3.26c0,0.99,0.04,1.86-0.03,2.71c-0.1,0.28-0.33,0.49-0.62,0.56c-1.91,0.05-3.82,0.03-5.91,0.03V121.25z"/>
              <path class="AddNewDevice-st2" d="M-325.32,121.17v-3.14h16.31v3.14H-325.32z"/>
              <path class="AddNewDevice-st2" d="M-331.88,141.03v-9.84h3.2v6.55h6.51v3.29L-331.88,141.03z"/>
              <path class="AddNewDevice-st2" d="M-305.47,94.85h-6.67v-3.21h9.77v9.81h-3.11V94.85z"/>
              <path class="AddNewDevice-st2" d="M-355.02,101.47h-3.24v-9.82h9.66v3.15h-6.41V101.47z"/>
              <path class="AddNewDevice-st2" d="M-302.33,147.6h-9.81v-3.21h6.59v-6.51h3.23L-302.33,147.6z"/>
              <path class="AddNewDevice-st2" d="M-312.25,137.82c0-1.96,0.07-3.66-0.02-5.36c-0.06-1.11,0.28-1.53,1.39-1.38c0.61,0.04,1.22,0.05,1.83,0.01V141h-9.66v-3.17H-312.25z"/>
              <path class="AddNewDevice-st2" d="M-358.25,137.86h3.13v6.46h6.52v3.24h-9.65V137.86z"/>
              <path class="AddNewDevice-st2" d="M-321.96,131.19v-6.56h13.02c-0.03,0.67-0.03,1.34,0.01,2.01c0.1,0.93-0.23,1.24-1.18,1.21c-2.45-0.06-4.91,0.02-7.37-0.05c-1.03-0.03-1.44,0.29-1.34,1.34c0.04,0.67,0.04,1.33,0.01,2l0.03-0.03l-3.23,0.06L-321.96,131.19z"/>
              <path class="AddNewDevice-st2" d="M-328.73,108.06h-3.12v-9.72h3.12V108.06z"/>
              <path class="AddNewDevice-st2" d="M-331.76,114.6c-0.1-0.17-0.14-0.21-0.14-0.24c-0.05-3.4-0.73-3.11,3.14-2.86v3.11H-331.76z"/>
              <path class="AddNewDevice-st2" d="M-348.56,118.07v3.09h-3.17v-3.09H-348.56z"/>
              <path class="AddNewDevice-st2" d="M-322,131.16c-0.03,0.78-0.09,1.57-0.08,2.35c0.01,0.63-0.21,0.91-0.87,0.88c-0.74-0.03-1.48-0.01-2.33-0.01v-3.2c1.11,0,2.21,0,3.31,0L-322,131.16z"/>
              <path class="AddNewDevice-st2" d="M-318.81,131.13c0.37-0.01,0.75-0.03,1.12-0.04c2.25-0.01,2.61,0.41,2.14,2.67c-0.13,0.3-0.39,0.53-0.71,0.6c-2.47,0.32-2.57,0.22-2.55-2.28c0-0.33,0.02-0.66,0.04-0.99L-318.81,131.13z"/>
              <path class="AddNewDevice-st2" d="M-345.11,134.38v-3.23h3.22c0,0.9,0.04,1.76-0.03,2.61c-0.07,0.28-0.29,0.51-0.57,0.59C-343.34,134.42-344.2,134.38-345.11,134.38z"/>
              <path class="AddNewDevice-st2" d="M-345.11,104.89h3.15V108h-3.15V104.89z"/>
              <path class="AddNewDevice-st2" d="M-315.52,106.17c-0.01,1.95-0.02,1.84-2.02,1.97c-1.69,0.11-1.25-0.99-1.27-1.86c-0.02-1.48,0.01-1.37,2.01-1.5C-315.24,104.68-315.49,105.61-315.52,106.17z"/>
            </g>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.AddNewDevice_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.AddNewDevice_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="AddNewDevice-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next" bgColor="#1EA5DE" iconRight="scanQR" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" :iconRightPadding="8" :useLanguageDirection="true" textColor="#FFFFFF">
        {{$store.getters.language.texts.AddNewDevice_button}}
      </CustomButton>
    </div>
    <div v-if="appMode != 'phonegap'" class="AddNewDevice-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next2" bgColor="#1EA5DE" iconRight="scanQR" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.AddNewDevice_button2}}
      </CustomButton>
    </div>
    <div class="AddNewDevice-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next3" bgColor="#1EA5DE" iconRight="edit" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.AddNewDevice_button3}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'
import * as CONFIGS from '@/statics/configs.js'

export default {
  name: 'AddNewDevice',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton
  },
  computed: {
    appMode: function () {
      return CONFIGS.APP_MODE;
    }
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    next: function () {
      this.$router.push('/addNewDeviceScanQR');
    },
    next2: function () {
      this.$router.push('/addNewDeviceUploadQR');
    },
    next3: function () {
      this.$router.push('/addNewDeviceManual');
    },
  }
}
</script>

<style>
  .AddNewDevice-topCurve-wrapper {
    height: 200px;
  }
  .AddNewDevice-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .AddNewDevice-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.AddNewDevice-st0 {
    fill: #ECECEC;
  }
	.AddNewDevice-st1 {
    fill: #54636C;
  }
	.AddNewDevice-st2 {
    fill: #21A4DE;
  }
</style>
